import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import './scss/index.scss';
import './index.css';
import './App.css';
import 'mdb-react-file-upload/dist/css/file-upload.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import 'mdb-react-wysiwyg/dist/css/wysiwyg.min.css';
import AuthLayer from './AuthLayer';
import reportWebVitals from './reportWebVitals';

import './utils/i18n';

// Initialize Sentry
Sentry.init({
  dsn: "https://eb58ab44de7dfaf09ea1da7d2eb6f4f0@o4510242314452992.ingest.de.sentry.io/4510242316353616",
  release: process.env.REACT_APP_GIT_SHA ?? "local",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^https:\/\/app\.cleanroom-processes\.de/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Enable logs to be sent to Sentry
  enableLogs: true,
  // Filter out expected user input validation errors
  beforeSend(event, hint) {
    const error = hint.originalException;

    // List of expected user input errors from AWS Cognito and auth flows
    // These are not application bugs, but expected user behavior
    const expectedAuthErrors = [
      'CodeMismatchException',           // Invalid verification code
      'UserNotFoundException',            // User doesn't exist
      'NotAuthorizedException',           // Wrong password or unauthorized
      'UsernameExistsException',          // Username already exists
      'InvalidPasswordException',         // Password doesn't meet requirements
      'InvalidParameterException',        // Invalid input parameters
      'LimitExceededException',           // Too many attempts
      'ExpiredCodeException',             // Verification code expired
      'AliasExistsException',             // Email/phone already in use
      'TooManyRequestsException',         // Rate limiting
      'TooManyFailedAttemptsException',   // Too many failed login attempts
    ];

    // Check if the error name matches any expected auth error
    if (error && error.name && expectedAuthErrors.includes(error.name)) {
      // Don't send to Sentry - return null to drop the event
      return null;
    }

    // Check if the error message contains expected patterns
    if (error && error.message) {
      const expectedMessagePatterns = [
        'Invalid verification code provided',
        'Incorrect username or password',
        'User does not exist',
        'Password does not conform to policy',
        'Temporary password has expired',
      ];

      if (expectedMessagePatterns.some(pattern => error.message.includes(pattern))) {
        return null;
      }
    }

    // For all other errors, send to Sentry
    return event;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  //   <AuthLayer />
  // </React.StrictMode>
  <AuthLayer />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
